import React from "react";
import { useLocation } from "react-router-dom";
import ModuleSubtopic from "../../../ModuleSubtopic";

const IEEEStandardsModule = () => {
  const location = useLocation();
  const { subtopics, subjectPath } = location.state || { subtopics: [], subjectPath: '' };

  return (
  <ModuleSubtopic
      subtopics={subtopics}
      subjectPath={subjectPath}
      title="IEEE Standards (802.3 Ethernet, 802.11 WLAN), RFID, Bluetooth"
    videos={[
      "https://www.youtube.com/embed/ewpq3qxx5Ls",
      "https://www.youtube.com/embed/t3FVP5wuG4g",
      "https://www.youtube.com/embed/ixY0Cau4mBM"
    ]}
    takeaways={[]}
    questions={[
      "X is working as a Business Development Lead in a leading MNC and keeps traveling frequently. X is also given the task of attending online meetings even in transit. An urgent meeting was called for when X was about to board his flight and there was a poor network in his mobile. X contacted the helpdesk requesting for internet connection. Which IEEE standard would help to connect to the airline’s internet service? Enumerate the architecture involved in connecting to the airline’s internet service.",
      "A girl faces an uncomfortable situation while she is travelling in a bus. She immediately alerts her parents using the safety device attached in her mobile phone. Identify the type of connectivity/standards employed in the device with its features."
    ]}
    exampleVideos={[]}
  />
);
}

export default IEEEStandardsModule;
